import { apiInstanceV1 } from "../instances/apiInstanceV1"
import {
    AddStickerRequest,
    AddStickerResponse,
    DeleteStickerRequest,
    DeleteStickerResponse,
    EditStickerRequest,
    EditStickerResponse,
    GetAllStickersResponse
} from "../../models/sticker"
import { queryApi } from "../api"

const stickersController = {
    getStickers: (projectId: string): Promise<GetAllStickersResponse> =>
        apiInstanceV1
            .post("stickers/get-all-stickers", {
                CustomerId: projectId
            })
            .then(response => response.data),
    create: (request: AddStickerRequest): Promise<AddStickerResponse> =>
        apiInstanceV1.put("stickers", request).then(response => response.data),
    update: (request: EditStickerRequest): Promise<EditStickerResponse> =>
        apiInstanceV1.post("stickers", request).then(response => response.data),
    delete: (request: DeleteStickerRequest): Promise<DeleteStickerResponse> =>
        apiInstanceV1.delete("stickers", { data: request }).then(response => response.data)
}

export const stickersApiController = queryApi.injectEndpoints({
    endpoints: build => {
        return {
            getStickers: build.query<GetAllStickersResponse, string>({
                query: projectId => ({
                    url: "stickers/get-all-stickers",
                    method: "POST",
                    body: {
                        CustomerId: projectId
                    },
                    baseUrl: "/api"
                })
            })
        }
    }
})

export const { useLazyGetStickersQuery } = stickersApiController

export default stickersController
